import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ModalState } from './types';

const initialState: ModalState = {};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ id: string; data?: unknown }>
    ) => {
      state[action.payload.id] = { isOpen: true, data: action.payload.data };
    },
    // Deleting the entry clears both isOpen and data so dependent effects clean up.
    closeModal: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
    closeAllModals: () => ({}),
  },
});

export const { openModal, closeModal, closeAllModals } = modalSlice.actions;
export const modalReducer = modalSlice.reducer;
